import { render } from "./attractionsResultsList.vue?vue&type=template&id=1a73383e"
import script from "./attractionsResultsList.vue?vue&type=script&lang=js"
export * from "./attractionsResultsList.vue?vue&type=script&lang=js"
script.render = render

export default script